module.exports = __webpack_public_path__ + "static/assets/fe96b322ada9257d71a12f5adcb0f886.svg";